var EHDI = EHDI || Object.create(null);

EHDI.component = EHDI.component || Object.create(null);

EHDI.component.HudContainer = function() {
    EHDI.aka.Container.call(this);
	
    var POWER_DUR = 40;
    
    var _this = this;
    var _buttons = [];
    var _bgFill;
    
    var _powerTimer = POWER_DUR;
    var _hideTimeline = new TimelineMax( { autoRemoveChildren: true } ), 
        _showTimeline = new TimelineMax( { autoRemoveChildren: true } );
    
    EHDI.GAME.gameScene.pauseManager.addTimelineInterrupt( _hideTimeline );
    EHDI.GAME.gameScene.pauseManager.addTimelineInterrupt( _showTimeline );
    
    var createPowerButtons = function(){
        var posX = -0.33;
        var cirHeight = 0;
        var powerData = EHDI.GAME.dataManager.getData().powerups;
        
        for( var i = 0; i < 4; i++ ){
            var btnCont = new EHDI.aka.Container();
            
            var btnAsset = ( i < 2 ) ? "hat_icon" : "hook_icon";
            btnAsset = btnAsset + ( i % 2 + 1 );
            var disabledAsset = "dark_" + btnAsset;
            
            var btn = new EHDI.displays.Button( EHDI.Assets.images[btnAsset], null, null, EHDI.Assets.images[disabledAsset], 0.9 );
            btn.setOnClickFunction( onPowerClicked, [i + 2] );
            btn.zIndex = 3;
            btn.setDisabled( true );
            btn.hitArea = new PIXI.Circle( btn.position.x, btn.position.y, btn.width * 0.37);
            
            var btnBg = new EHDI.aka.Sprite( EHDI.displays.TextureCircle(0x231D19, btn.width * 0.23) );
            btnBg.anchor.set( 0.5, 0.55 );
            btnBg.zIndex = 1;
            cirHeight = btnBg.height;
            
            var stockLabel = new EHDI.aka.PixiText( "x " + powerData[i].stock, {
                fontFamily: "dimboregular", 
                fontSize: 27, 
                align: 'center', 
                fill: '#000000' 
            });
            stockLabel.anchor.set( 1.0, 1.0 );
            stockLabel.position.set( btn.width * 0.50, btn.height * 0.48 );
            
            btnCont.addChild( btnBg );
            btnCont.addChild( btn );
            btnCont.addChild( stockLabel );
            
            btnCont.position.set( EHDI.screen.viewWidth * posX, EHDI.screen.viewHeight * 0.675 );
            _this.addChild( btnCont );
            _buttons.push( btnCont );
            
            posX += 0.22;
        }
        // green bg = 0x91ff03
        //console.log( "circle height is " + cirHeight );
        
        _bgFill = new EHDI.aka.Sprite( EHDI.displays.TextureRectangle(0x91FF03, cirHeight, cirHeight) );
        _bgFill.anchor.set( 0.5, 1 );
        _bgFill.zIndex = 2;
    }
    
    var onPowerClicked = function( e ){
        EHDI.GAME.soundManager.playSFX("powerup_equip");
        
        _powerTimer = POWER_DUR;
        EHDI.GAME.dataManager.usePowerup( e - 2 );
        EHDI.GAME.achieveManager.updateTriedPower( e - 2 );
        EHDI.GAME.gameScene.equipPower( e );
        _this.hideButtons( true, e );
    }
    
    this.update = function( dt ){
        _powerTimer -= dt;
        _bgFill.height = _bgFill.width * ( _powerTimer / POWER_DUR );
        
        if( _powerTimer < 0 ){
            _powerTimer = POWER_DUR;
            EHDI.GAME.gameScene.resetPower();
        }
    }
    
    this.setPowerEquipped = function( index ){
        if( _bgFill.parent != null ){
            _bgFill.parent.removeChild(_bgFill);
        }
        
        var curBtn = _buttons[index];
        curBtn.addChild( _bgFill );
        _bgFill.position.y = _bgFill.height * 0.45;
        
        curBtn.children.sort(function(a,b) {
            a.zIndex = a.zIndex || 0;
            b.zIndex = b.zIndex || 0;
            return a.zIndex - b.zIndex;
        });
    }
    
    this.hideButtons = function( show, index ){
        var followShow = show || false;
        var equipIndex = index || -1;
        
        if( _hideTimeline ) _hideTimeline.kill();
        _hideTimeline = new TimelineMax();
        
        _hideTimeline.add( "hide", "+=0" );
        for( var i = 0; i < _buttons.length; i++ ){
            var curBtn = _buttons[i];
            for( var j = 0; j < curBtn.children.length; j++ ){
                if( curBtn.children[j] instanceof EHDI.displays.Button ) curBtn.children[j].setDisabled( true );
                if( curBtn.children[j] instanceof EHDI.aka.PixiText ) curBtn.children[j].visible = false;
            }
            
            if( curBtn.position.y !== EHDI.screen.viewHeight * 0.675 && i !== ( equipIndex - 2 ) ){
                _hideTimeline.add( TweenMax.to( curBtn, 0.3, { y: EHDI.screen.viewHeight * 0.675, ease : Power0.easeNone } ), "hide" );
                _hideTimeline.addCallback( function( button ){
                    button.visible = false;
                }, "+=0", [curBtn] );
            }
            else{
                _hideTimeline.add( TweenMax.to( curBtn, 0.3, { x: EHDI.screen.viewWidth * -0.4, ease : Power0.easeNone } ), "hide" );
            }
        }
        
        if( followShow ){
            _hideTimeline.addCallback( _this.showButtons, "+=0.1", [ equipIndex ] );
        }
    }
    
    this.showButtons = function( index ){
        var showIndex = index || -1;
        if( showIndex > 0 ) showIndex -= 2;
        var powerData = EHDI.GAME.dataManager.getData().powerups;
        
        if( _showTimeline ) _showTimeline.kill();
        _showTimeline = new TimelineMax();
        
        if( showIndex !== -1 ){
            _bgFill.scale.y = 1;
            _bgFill.height = Math.abs( _bgFill.width ) ;
            
            var showButton = _buttons[ showIndex ];
            showButton.visible = true;
            showButton.position.x = EHDI.screen.viewWidth * -0.4;
            _this.setPowerEquipped( showIndex );
            
            //_showTimeline.add( TweenMax.to( showButton, 0.3, { y: EHDI.screen.viewHeight * 0.375, ease : Power0.easeNone } ) );
            _bgFill.height = 0;
            _showTimeline.add( TweenMax.to( _bgFill, 0.3, { height: _bgFill.width, ease : Power0.easeNone } ) );
        }
        else{
            _hideTimeline.add( "show", "+=0" );
            
            var posX = -0.3;
            for( var i = 0; i < _buttons.length; i++ ){
                var curBtn = _buttons[i];
                curBtn.visible = true;
                for( var j = 0; j < curBtn.children.length; j++ ){
                    if( curBtn.children[j] instanceof EHDI.displays.Button ){
                        if( EHDI.GAME.dataManager.getData().powerups[i].stock === 0 ){
                            curBtn.children[j].disable( true );
                        }
                        else{
                            curBtn.children[j].disable( false );
                            curBtn.children[j].setDisabled( false );
                        }
                    }
                    else if( curBtn.children[j] instanceof EHDI.aka.PixiText ){
                        var label = curBtn.children[j];
                        label.text = "x " + powerData[i].stock;
                        label.visible = true;
                    }
                }
                
                if( curBtn.position.y === EHDI.screen.viewHeight * 0.375 ) continue;
                
                curBtn.position.set( EHDI.screen.viewWidth * posX, EHDI.screen.viewHeight * 0.675 );
                _showTimeline.add( TweenMax.to( curBtn, 0.3, { y: EHDI.screen.viewHeight * 0.375, ease : Power0.easeNone } ), "show" );
                
                posX += 0.2;
            }
        }
    }
    
    createPowerButtons();
}

EHDI.component.HudContainer.prototype = Object.create(EHDI.aka.Container.prototype);